(function(){
 
    
  let movements = [];

  let tsm = null;

  let lastPos;

  let lastTime;

  let suspectScore = 0;

  let lastLength = 0;

  let defaultLimit = 20;

  let tmsUserID = null;

  let streamUserID = null;

  let currentDomain = null;

  let isUserIDUpdated = false;

  let updateError = 2;

  const isTouchCapable = () => {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0 // For older IE
    );
  };
  
  function getSignature() {

      var singnatureSamples = movements.filter((x, i) => { return i < 16 });
      var signatureValue = singnatureSamples.reduce((x, y, i) => {
          return x + '|' + Math.round(y.dx + y.dy + y.dt + y.velocity);
      }, '');
      return btoa(signatureValue);
  }

  function recordMovement(x, y) {
      const now = Date.now();
      if (lastPos && lastTime) {
          const dx = x - lastPos.x;
          const dy = y - lastPos.y;
          const dt = now - lastTime;
          const distance = Math.sqrt(dx * dx + dy * dy);
          const velocity = distance / dt;
          movements.push({ dx, dy, dt, velocity });
          if(movements.length>100)movements.shift();
      }
      lastPos = { x, y };
      lastTime = now;
  }

  function huristicAdaption(points) {
    let totalDx = 0, totalDy = 0, totalDt = 0;
    let totalDist = 0;
    let velocities = [];
    points.forEach(p => {
        totalDx += p.dx;
        totalDy += p.dy;
        totalDt += p.dt;
        let dist = Math.sqrt(p.dx * p.dx + p.dy * p.dy);
        totalDist += dist;
        velocities.push(dist / (p.dt || 1e-5)); // avoid divide by zero
    });
    // Feature extraction
    let avgVel = velocities.length ? velocities.reduce((a, b) => a + b, 0) / velocities.length : 0;
    let direction = Math.atan2(totalDy, totalDx); // angle in radians, -π to π

    // Non-linear scaling and normalization
    // velocity: [0, max], direction: [-π, π], totalDist: scale as you wish
    let r = Math.round(255 * Math.min(1, avgVel / 5)); // scale velocity, or use other non-linear (logistic, sqrt, etc)
    let g = Math.round(255 * (direction + Math.PI) / (2 * Math.PI)); // normalize angle to [0,1]
    let b = Math.round(255 * Math.min(1, totalDist / 100)); // scale total distance, or another feature

    return [r, g, b];
  }


  function rgbToGrayWight(r, g, b) {
    const gray = 0.299 * r + 0.587 * g + 0.114 * b;  // Accurate grayscale
    return Math.round(gray / 255 * 100);  // Scale to 0-100
  }




  function onRecord()
  {
    document.addEventListener("mousemove", e => recordMovement(e.clientX, e.clientY));
    document.addEventListener("mousedown", e => recordMovement(e.clientX, e.clientY));
    document.addEventListener("touchstart", e => {
        const t = e.touches[0];
        if(t && t.clientX)
          recordMovement(t.clientX, t.clientY);
    });

    document.addEventListener("touchend", e => {
        const t = e.touches[0];
        if(t && t.clientX)
          recordMovement(t.clientX, t.clientY);
    });

    document.addEventListener("touchmove", e => {
        const t = e.touches[0];
        if(t && t.clientX)
          recordMovement(t.clientX, t.clientY);
    });

    document.addEventListener("scroll", e=>{        
        recordMovement(window.scrollX, window.scrollY);
    });
  }

  function getSuspectAutomationScore(){
    if(navigator.webdriver|| window.chrome?.runtime?.sendMessage ||/HeadlessChrome|Chrome-Lighthouse/i.test(navigator.userAgent))return 1000;
    if(navigator.languages?.length==0)return 500;
    try {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        const softwareRenderers = ['SwiftShader', 'llvmpipe', 'softpipe', 'swrast', 'Basic Render Driver'];
        if (gl) {
            const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
            const renderer = debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER);            
            if (softwareRenderers.some(r=>renderer.toLowerCase().includes(r.toLowerCase()))) {
                return 700;
            }
        }
    } catch (e) {        
    }
    let cdpDetected = false;
    const e = new Error();
    Object.defineProperty(e, 'stack', {
        get() {
            cdpDetected = true;
        }
    });
    if(cdpDetected)
      return 500;

    /*
    try {
      const key = '__ls_test__';
      const storage = window.localStorage;
      storage.setItem(key, '1');
      storage.removeItem(key);
    } catch (e) {      
      return 300;
    }

    let primaryCookie = document.cookie.match(('AGID\s?\=\s?(?<MM>\\d{2})(?<dd>\\d{2})(?<yyyy>\\d{4})(?<HH>\\d{2})(?<mm>\\d{2})(?<ss>\\d{2})(?<fffff>\\d{5})'));
    if(!primaryCookie || primaryCookie==null || !primaryCookie.groups) return 300;
    let cookieDate = new Date(Date.parse(`${primaryCookie.groups.yyyy}-${primaryCookie.groups.MM}-${primaryCookie.groups.dd}T${primaryCookie.groups.HH}:${primaryCookie.groups.mm}:${primaryCookie.groups.ss}.${primaryCookie.groups.fffff}Z`));
    let currentDate = new Date();
    let timeDiff = Math.abs(currentDate.getTime() - cookieDate.getTime()); */   
    let currentValue = getCurrentValue();
    /*if(timeDiff>10*1000&&(currentValue==null||!currentValue.count))return 300;*/
    //if(!(window.innerWidth==window.outerWidth&&window.innerHeight==window.outerHeight))return 400;
    //if(!('ontouchstart' in window)&&navigator.maxTouchPoints>0)return 400;    
    if((currentValue&&currentValue!=null&&currentValue.domain&&window.location.indexOf(currentValue.domain)==-1&&currentValue.domain.indexOf(window.location.hostname)==-1)||(currentDomain!=null&&window.location.indexOf(currentDomain)==-1&&currentDomain.indexOf(window.location.hostname)==-1))return 101;
    if(suspectVPN())return 100;    
    return 0;
  }

  function isHuman(limit) {
      if(suspectScore>0)limit = suspectScore;
      if (movements.length - lastLength < (limit?limit:defaultLimit)) return false;
      lastLength = movements.length - 1;
      let varying = movements.some((m, i, arr) => i > 0 && (Math.abs(m.velocity - arr[i - 1].velocity) > 0.05));
      let nonLinear = movements.some((m, i, arr) => i > 1 && (Math.abs(m.dx - arr[i - 1].dx) > 0.1 || Math.abs(m.dy - arr[i - 1].dy) > 0.1));
      let irregular = movements.some(m => m.dt > 50 && m.dt < 500);      
      return varying && nonLinear && irregular;
  }

  function halucinateClient(){
    //updateScore(false,-1);
  }

  function updateId(){
    return new Promise((idresolve,idreject)=>{
      try{
        fetch('/traffic/id',{method:'GET'}).then(res=>res.json()).then(data=>{
            if(data && data.id){
                let currentValue = getCurrentValue();
                if(currentValue==null)currentValue={};
                currentValue.id = data.id;
                currentValue.uid = data.id;
                tmsUserID = data.id;
                setCurrentValue(currentValue);
                idresolve(data.id);
            }else{
                halucinateClient();
                idreject();
            }
          }).catch(ex=>{ halucinateClient();idreject();});
      }catch(ex){ halucinateClient();idreject(); }
    });
  }

  function getUId(){
    return new Promise((idresolve,idreject)=>{
      try{
        fetch('/traffic/uid',{method:'GET'}).then(res=>res.json()).then(data=>{
            if(data && data.id){
                let currentValue = getCurrentValue();
                if(currentValue==null)currentValue={};
                currentValue.uid = data.id;
                currentValue.domain = data.domain;
                tmsUserID = data.id;
                currentDomain = data.domain;
                setCurrentValue(currentValue);
                idresolve(tmsUserID);
            }else{
                idresolve('MC4wLjAuMA==');
            }
          }).catch(ex=>{ idresolve('MC4wLjAuMA=='); });
      }catch(ex){ idresolve('MC4wLjAuMA=='); }
    });
  }

  function webScrapRequestReminder(){
    // Disabled
  }

  function updateScore(isInit,forcedScoreToUpdate){
    let isHumanResult = isHuman();
    if(isHumanResult||isInit||typeof(forcedScoreToUpdate)!='undefined'||suspectScore>0){       
        var hashValue = isInit&&!isHumanResult?getScoreFromLocal():getHash(typeof(forcedScoreToUpdate)!='undefined'?forcedScoreToUpdate:suspectScore); 
        if(hashValue==null||updateError<=0)return;
        let src = "/tfp/"+hashValue+'.png';
        var image = new Image();
        image.onload = function() {
            if(!document.body.hasAttribute('r-id') && isImageMostlyBlack(image)){
                let curretValue = getCurrentValue();
                //Disabled for reduce hits
                //if(!curretValue.token||(curretValue.token&&curretValue.token!='UN')){
                if(curretValue!=null&&curretValue.id&&suspectScore<100&&curretValue.token&&curretValue.token!='UN'&&curretValue.token!='NA'){
                {
                  updateId().then(data=>{
                    /*if(!curretValue.token)
                    {
                      curretValue.token='NA';
                      setCurrentValue(curretValue);
                    }*/
                  }).catch(e=>{
                    curretValue.token='UN';
                    setCurrentValue(curretValue);
                  });
                }
              }
            }else{

            }
            if(suspectScore>0){
              webScrapRequestReminder();
            }
        };
        image.onerror = function() {
          if(updateError<=0) return;
          updateError--;          
          let shareUrl = document.querySelector('meta[property="og:url"]') ? document.querySelector('meta[property="og:url"]').getAttribute("content") : window.location.href;
          let domainExtractedMatch = shareUrl.match(/^(?:https?:\/\/)?(?:www\.)?([^\/]+)/i);
          let domainExtracted = domainExtractedMatch ? domainExtractedMatch[0] : null;
          if(domainExtracted!=null){
            image.src = domainExtracted+src;
          }
        };
        image.src = src;
    }    
  }

  function updateScoreToLocal(){
    if(isHuman()){        
        let currentValue = getCurrentValue();
        if(currentValue==null)currentValue={};
        currentValue.hash = getHash(suspectScore);
        setCurrentValue(currentValue);
    }
  }

  function getScoreFromLocal(){
    let currentValue = getCurrentValue();
    let valueToSend = null;
    if(currentValue!=null&&currentValue.hash)
    {
      valueToSend = currentValue.hash;
      delete currentValue.hash;
      setCurrentValue(currentValue);
    }
    return valueToSend;
  }

  function getHash(suspectScoreDetected){
    let rgb = suspectScoreDetected==0?huristicAdaption(movements):[0,0,0];
    let score = suspectScoreDetected==0?rgbToGrayWight(rgb[0],rgb[1],rgb[2]):(suspectScoreDetected==1?1:-1);    
    let id = tsm && tsm.id ?'U-'+ tsm.id : 'UN';
    return btoa(`${id}|${score}|${rgb[0]}|${rgb[1]}|${rgb[2]}|${suspectScoreDetected??0}`).replace(/[^A-z0-9\.]/gi,'-e');
  }

  function getCurrentValue()
  {
    if(window.localStorage.getItem("TSM")==null)return null;
    return JSON.parse(window.localStorage.getItem("TSM"));
  }

  function suspectVPN(){
    if(streamUserID!=null&&tmsUserID!=null&&btoa('U-'+atob(tmsUserID))!=atob(streamUserID))return true;
    return false;
  }

  function getCurrentEventStreamID(){
    if(window.localStorage.getItem("AGSTREAM")==null)return null;
    return window.localStorage.getItem("AGSTREAM");
  }

  function setCurrentValue(value)
  {
    window.localStorage.setItem("TSM", JSON.stringify(value));
    return true;
  }

  function isImageMostlyBlack(image, opts = {}) {
    const threshold = opts.threshold ?? 20;   // 0–255, max brightness to count as black
    const ratio     = opts.ratio ?? 0.95;     // fraction of pixels that must be black

    const w = image.naturalWidth;
    const h = image.naturalHeight;

    // Downscale to speed up: sample at most 200x200
    const maxSize = 200;
    const scale = Math.min(1, maxSize / Math.max(w, h));

    const canvas = document.createElement('canvas');
    canvas.width  = Math.max(1, Math.floor(w * scale));
    canvas.height = Math.max(1, Math.floor(h * scale));
    const ctx = canvas.getContext('2d');

    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

    const { data, width, height } = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const totalPixels = width * height;

    let blackPixels = 0;
    for (let i = 0; i < data.length; i += 4) {
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];
      const a = data[i + 3];

      // Treat transparent pixels as non‑black (optional)
      if (a === 0) continue;

      // brightness via simple max channel
      const brightness = Math.max(r, g, b);

      if (brightness <= threshold) {
        blackPixels++;
      }
    }

    return blackPixels / totalPixels >= ratio;
  }

  let startPeriod = 5000;
  let startIndex = 10;
  let currentIndex = 0;

  function autoUpdate(isInit){
    updateScore(isInit);
    currentIndex++;
    if(currentIndex<startIndex)
    setTimeout(() => {
        autoUpdate(false);        
    }, startPeriod*currentIndex);
  }

  function start(){
    autoUpdate(true);
    document.addEventListener('click',()=>{updateScore(false);});
    document.addEventListener('touchend',()=>{updateScore(false);});  
    window.addEventListener('beforeunload',()=>{updateScoreToLocal();});
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        updateScoreToLocal();
      }
    });  
  }

  function attachListener(){
    document.body.addEventListener('ag.tsm.valid',(e)=>{
        let currentValue = getCurrentValue();
        if(currentValue==null)currentValue={};
        currentValue.token = e.detail.token;
        currentValue.id = e.detail.id;
        setCurrentValue(currentValue);
    });
  }

  function updateTSM(){
    tsm = getCurrentValue();   
    let tsmElement = document.getElementById('agTSM');
    if(tsmElement!=null){
      let tsmValue = JSON.parse(tsmElement.textContent);
      if(tsmValue!=null){
        if(tsm == null || !tsm.id || !tsm.uid || tsm.id!=tsmValue.id){
          if(tsm==null)tsm={};
          tsm.uid = tsm.id = tsmValue.id;
          setCurrentValue(tsm);
        }
      }
    }
    if(tsm!=null&&tsm.uid){
      tmsUserID = tsm.uid;
      streamUserID = getCurrentEventStreamID();
    }
    return tsmElement!=null;
  }

  function afterUpdatingUserID(){
    if(suspectVPN()){
      suspectScore = getSuspectAutomationScore();
      updateScore(false,-1);
    } 
  }

  function init(){
    
    if(updateTSM()){
      document.addEventListener('DOMContentLoaded',()=>{
        updateTSM();
        afterUpdatingUserID();
      });
    }
    
    if(document && document.body && document.body!=null && document.body.hasAttribute('r-id')){
      attachListener();
    }
    else{
      suspectScore = getSuspectAutomationScore();
      defaultLimit = isTouchCapable()?2:20;
      if(tsm==null||!tsm.valid){
          onRecord();
          start();
      }

      let currentValue = getCurrentValue();
      if(currentValue==null)currentValue={};
      if(currentValue.count)currentValue.count++;
      else currentValue.count=1;
      if(currentValue.count<10)
        setCurrentValue(currentValue);

      window.addEventListener('ag.event.stream',(e)=>{
        streamUserID = e.detail.streamKey;
        afterUpdatingUserID();
      });      
      if(window.agEvent){
        window.dispatchEvent(new CustomEvent('ag.event.stream.update'));
      }
    }
  }
 
  init();

})();


